export enum InputState {
  Disabled = 'disabled',
  Focused = 'focused',
  Idle = 'idle',
  Invalid = 'Invalid',
}

export function findInputState(disabled = false, focused = false, error = '', readOnly = false) {
  if (disabled || readOnly) {
    return InputState.Disabled
  }
  if (error) {
    return InputState.Invalid
  }
  if (focused) {
    return InputState.Focused
  }

  return InputState.Idle
}
